/**
 * v2 route paths. Owned by v2 — do not import from legacy.
 *
 * Paths intentionally match the legacy URLs for the same concepts so the
 * device-detection switch in src/index.tsx serves the right experience for
 * a given URL without redirects. New v2-only routes go here as features land.
 */
export const ROUTE_AUDITS = '/audits';
export const ROUTE_AUDIT_DETAIL = '/audits/details';
export const ROUTE_PERFORM_AUDIT = '/audits/perform';
export const ROUTE_TASKS = '/tasks';
export const ROUTE_TASK_DETAIL = '/tasks/details';
export const ROUTE_PROFILE_PREFERENCES = '/preferences';
export const ROUTE_GENERATE_QUESTIONS = '/question/generate';
export const ROUTE_REVIEW_QUESTIONS = '/question/generate/review';

export type V2RoutePath =
  | typeof ROUTE_AUDITS
  | typeof ROUTE_AUDIT_DETAIL
  | typeof ROUTE_PERFORM_AUDIT
  | typeof ROUTE_TASKS
  | typeof ROUTE_TASK_DETAIL
  | typeof ROUTE_PROFILE_PREFERENCES
  | typeof ROUTE_GENERATE_QUESTIONS
  | typeof ROUTE_REVIEW_QUESTIONS;
